export default __webpack_public_path__ + "images/profile0.jpg";